import { makeAutoObservable } from 'mobx'
import apiService from 'Service'
import FileDownload from 'js-file-download'
import { toApiCivilDate } from 'Utilities/dateTime'

class txtStore {
  isFetching = true
  isGenerating = false
  txts = []
  lastTxtDate = null
  pendingCount = null
  pendingFrom = null
  pendingTo = null

  constructor() {
    makeAutoObservable(this)
  }

  createTxt(txtDate, fileName = 'retenciones') {
    const date = toApiCivilDate(txtDate)
    if (!date) throw new Error("'txtDate' param is required")

    this.isGenerating = true
    return apiService.Withholding.exportTxt(date).then(data => {
      if (data) {
        FileDownload(data, `${fileName}_${date}.txt`)
        return true
      }
      return false
    }).finally(() => {
      this.isGenerating = false
    })
  }

  downloadTxt(txtNumber, fileName = 'retenciones') {
    if (!txtNumber) throw new Error("'txtNumber' param is required")

    return apiService.Withholding.downloadTxt(txtNumber).then(data => {
      if (data) {
        FileDownload(data, `${fileName}_${txtNumber}.txt`)
      }
    })
  }

  fetchTxts(from, to) {
    if (!from) throw new Error("'from' param is required")
    if (!to) throw new Error("'to' param is required")

    this.isFetching = true
    apiService.Withholding.getGeneratedTxts(from, to).then(data => {
      this.txts = Array.isArray(data) ? data : []
    }).catch(() => {
      this.txts = []
    }).finally(() => {
      this.isFetching = false
    })
  }

  fetchLastTxtDate() {
    return apiService.Withholding.getLastTxtGenerateDate().then(data => {
      this.lastTxtDate = data?.LastTxtDate || null
      return this.lastTxtDate
    }).catch(() => {
      this.lastTxtDate = null
      return null
    })
  }

  fetchPendingForTxt(txtDate) {
    const date = toApiCivilDate(txtDate)
    if (!date) {
      this.pendingCount = null
      this.pendingFrom = null
      this.pendingTo = null
      return Promise.resolve(null)
    }

    return apiService.Withholding.getPendingForTxt(date).then(data => {
      this.pendingCount = data?.Count ?? 0
      this.pendingFrom = data?.FromDate || null
      this.pendingTo = data?.ToDate || null
      return data
    }).catch(() => {
      this.pendingCount = null
      this.pendingFrom = null
      this.pendingTo = null
      return null
    })
  }

  reset() {
    this.txts = []
    this.isFetching = true
    this.isGenerating = false
    this.lastTxtDate = null
    this.pendingCount = null
    this.pendingFrom = null
    this.pendingTo = null
  }
}

export default new txtStore()
